import { useEffect, useState } from "react";
import { useLocale } from "../i18n/LocaleContext";
import { LANGUAGE_NAMES, LOCALES, localePath } from "../i18n/config";
import { saveLocale } from "../i18n/detect";
import { extractDateFromURLPath } from "../lib/utils/gridLevels";

const ROUTE_PATHS = { home: "/", privacy: "/privacy" };

// Plain links so each language loads afresh with its own messages
export function LanguageSwitcher() {
  const { locale, route, t } = useLocale();
  const [path, setPath] = useState(ROUTE_PATHS[route] ?? "/");

  // The exported date page doesn't know its date until it runs in the browser
  useEffect(() => {
    if (route === "date") {
      setPath(`/${extractDateFromURLPath()}`);
    }
  }, [route]);

  return (
    <nav
      aria-label={t("footer.language")}
      className="mb-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm md:mb-8"
    >
      {LOCALES.map((option) =>
        option === locale ? (
          <span
            key={option}
            lang={option}
            aria-current="page"
            className="font-semibold text-gray-900"
          >
            {LANGUAGE_NAMES[option]}
          </span>
        ) : (
          <a
            key={option}
            href={localePath(option, path)}
            hrefLang={option}
            lang={option}
            onClick={() => saveLocale(option)}
            className="text-gray-600 hover:underline"
          >
            {LANGUAGE_NAMES[option]}
          </a>
        )
      )}
    </nav>
  );
}
